/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareHero.jsx

import React from "react";
import {
  Laptop,
  Smartphone,
  Rocket,
  Sparkles,
} from "lucide-react";

const SoftwareHero = () => {
  return (
    <section className="relative h-[750px] overflow-hidden">

      {/* Background */}

      <div
        className="
          absolute
          inset-0
          bg-cover
          bg-center
        "
      />

      {/* Overlay */}

      <div
        className="
          absolute
          inset-0
          bg-gradient-to-r
          from-black/75
          via-black/55
          to-black/25
        "
      />

      {/* Content */}

      <div
        className="
          absolute
          inset-0
          flex
          items-center
        "
      >

        <div
          className="
            w-full
            px-6
            lg:px-12
            xl:px-20
          "
        >

          <div className="max-w-5xl">

            {/* Tag */}

            <div
              className="
                inline-flex
                items-center
                gap-2
                px-4
                py-2
                rounded-full
                bg-white/10
                backdrop-blur-md
                border
                border-white/20
                text-white
                mb-6
              "
            >
              <Sparkles size={18} />

              Orion Software Ecosystem
            </div>

            {/* Heading */}

            <h1
              className="
                text-5xl
                lg:text-7xl
                font-black
                text-white
                leading-tight
                mb-8
              "
            >
              Financial Intelligence
              <span
                className="
                  block
                  text-blue-400
                "
              >
                Across Every Device
              </span>
            </h1>

            {/* Description */}

            <p
              className="
                text-white/85
                text-lg
                lg:text-xl
                leading-relaxed
                max-w-3xl
              "
            >
              Orion Software brings together
              web platforms, mobile applications
              and future intelligence products
              designed for investors, traders
              and financial professionals.
            </p>

            {/* CTA */}

            <div
              className="
                flex
                flex-wrap
                gap-5
                mt-10
              "
            >

              <a href="/software/#products">

                <button
                  className="
                    bg-blue-600
                    hover:bg-blue-700
                    text-white
                    px-8
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    shadow-xl
                    transition-all
                    hover:scale-105
                  "
                >
                  Explore Products
                </button>

              </a>

              <a href="/software/#roadmap">

                <button
                  className="
                    bg-white/10
                    hover:bg-white/20
                    backdrop-blur-md
                    border
                    border-white/20
                    text-white
                    px-8
                    py-4
                    rounded-2xl
                    font-bold
                    text-lg
                    transition-all
                  "
                >
                  Product Roadmap
                </button>

              </a>

            </div>

            {/* Stats */}

            <div
              className="
                flex
                flex-wrap
                gap-8
                mt-14
              "
            >

              <div className="flex items-center gap-3">

                <div
                  className="
                    w-12
                    h-12
                    rounded-xl
                    bg-blue-500/20
                    border
                    border-blue-400/20
                    flex
                    items-center
                    justify-center
                    text-blue-300
                  "
                >
                  <Smartphone size={22} />
                </div>

                <div>

                  <div
                    className="
                      text-white
                      font-bold
                    "
                  >
                    Orion Edge
                  </div>

                  <div
                    className="
                      text-white/60
                      text-sm
                    "
                  >
                    Mobile Toolkit
                  </div>

                </div>

              </div>


              <div className="flex items-center gap-3">

                <div
                  className="
                    w-12
                    h-12
                    rounded-xl
                    bg-green-500/20
                    border
                    border-green-400/20
                    flex
                    items-center
                    justify-center
                    text-green-300
                  "
                >
                  <Laptop size={22} />
                </div>

                <div>

                  <div
                    className="
                      text-white
                      font-bold
                    "
                  >
                    Orion Analytics
                  </div>

                  <div
                    className="
                      text-white/60
                      text-sm
                    "
                  >
                    Web Platform
                  </div>

                </div>

              </div>


              <div className="flex items-center gap-3">

                <div
                  className="
                    w-12
                    h-12
                    rounded-xl
                    bg-purple-500/20
                    border
                    border-purple-400/20
                    flex
                    items-center
                    justify-center
                    text-purple-300
                  "
                >
                  <Rocket size={22} />
                </div>

                <div>

                  <div
                    className="
                      text-white
                      font-bold
                    "
                  >
                    Orion Mobile
                  </div>

                  <div
                    className="
                      text-white/60
                      text-sm
                    "
                  >
                    Coming Soon
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default SoftwareHero;